enum ErrorMessage {
  RefundMethod = "Please select a refund method",
  ReturnReason = "Please select a return reason",
  Notes = "Please add comments",
}

export default ErrorMessage;
